import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Box from '../../Box';
import Tooltip from '../../Tooltip';
import { useCollapsibleRowsStore, useSubRowOpen, useAnySubRowsOpen } from '../hooks/useCollapsibleRows';
import Icon from '../components/Icon';
var buttonStyles = {
  appearance: 'none',
  display: 'flex',
  alignSelf: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 1,
  margin: 0,
  border: 'none',
  borderRadius: 3,
  backgroundColor: 'hsla(0, 0%, 0%, 0)',
  fill: 'foreground',
  cursor: 'pointer',
  ' &:focus ': {
    outline: 0
  },
  ' &:hover ': {
    backgroundColor: 'highlight'
  }
};

function CollapseHeader(_ref) {
  var accessibility = _ref.accessibility;
  var callbacks = useCollapsibleRowsStore(function (state) {
    return state.callbacks;
  });
  var anySubRowsOpen = useAnySubRowsOpen();
  var tooltipTitle = accessibility.toggleAllSubRowsTooltipTitle(anySubRowsOpen);
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipTitle,
    placement: "bottom-start"
  }, /*#__PURE__*/React.createElement(Box, {
    as: "button",
    display: "flex",
    "aria-label": tooltipTitle,
    css: buttonStyles,
    onClick: function onClick(event) {
      event.preventDefault();
      callbacks.toggleAllSubRows();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "arrow-down",
    size: "sm",
    style: {
      transform: anySubRowsOpen ? undefined : 'rotate(-90deg)',
      transition: 'transform 180ms ease'
    }
  })));
}

function CollapseCell(_ref2) {
  var rowIndex = _ref2.rowIndex;
  var callbacks = useCollapsibleRowsStore(function (state) {
    return state.callbacks;
  });
  var isSubRowOpen = useSubRowOpen(rowIndex);
  return /*#__PURE__*/React.createElement(Box, {
    as: "button",
    css: buttonStyles,
    onClick: function onClick(event) {
      event.preventDefault();
      callbacks.toggleSubRowAtIndex(rowIndex);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "arrow-down",
    size: "sm",
    style: {
      transform: isSubRowOpen ? undefined : 'rotate(-90deg)',
      transition: 'transform 180ms ease'
    }
  }));
}

function getParsedColumns(_ref3) {
  var accessibility = _ref3.accessibility,
      columns = _ref3.columns,
      hasSubRows = _ref3.hasSubRows,
      hiddenColumnIds = _ref3.hiddenColumnIds,
      draggable = _ref3.draggable;
  var nextColumns = columns.filter(function (column) {
    return column !== null && column !== false && column !== undefined && (column.alwaysVisible || hiddenColumnIds.indexOf(column.id) === -1);
  });

  if (hasSubRows) {
    nextColumns.unshift({
      header: /*#__PURE__*/React.createElement(CollapseHeader, {
        accessibility: accessibility
      }),
      cell: function cell(_, _ref4) {
        var rowIndex = _ref4.rowIndex;
        return /*#__PURE__*/React.createElement(CollapseCell, {
          rowIndex: rowIndex
        });
      },
      subCell: null,
      width: 32,
      css: {
        paddingLeft: draggable ? 0 : undefined,
        '@media print': {
          display: 'none !important'
        }
      }
    });
  }

  if (draggable) {
    nextColumns.unshift({
      cell: function cell(_, _ref5) {
        var _dragHandleProps = _ref5._dragHandleProps;
        return /*#__PURE__*/React.createElement(Box, _extends({
          css: buttonStyles,
          onClick: function onClick(event) {
            return event.preventDefault();
          }
        }, _dragHandleProps), /*#__PURE__*/React.createElement(Icon, {
          name: "drag-handle",
          size: "sm",
          color: "foregroundTertiary",
          style: {
            cursor: 'grab'
          }
        }));
      },
      subCell: null,
      width: 32,
      css: {
        paddingRight: hasSubRows ? 0 : undefined,
        '@media print': {
          display: 'none !important'
        }
      }
    });
  }

  return nextColumns;
}

export default getParsedColumns;